import { shouldPolyfill } from '@formatjs/intl-locale/should-polyfill.js'

// The detector stays in the entry. The locale data loads only when this polyfill
// reports a missing Intl.Locale behaviour, including ones added in later releases.
export function ensureIntlLocalePolyfill(): void {
  if (!shouldPolyfill()) return

  import('@formatjs/intl-locale/polyfill.js')
}
